"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ResourceType = /** @class */ (function () {
    function ResourceType() {
    }
    ResourceType.NewMessage = "NewMessage";
    ResourceType.MessageUpdate = "MessageUpdate";
    ResourceType.UserPresence = "UserPresence";
    ResourceType.ConversationUpdate = "ConversationUpdate";
    ResourceType.ThreadUpdate = "ThreadUpdate";
    return ResourceType;
}());
exports.default = ResourceType;
//# sourceMappingURL=ResourceType.js.map